import { Col, Form, message, Modal, notification, Row, Spin } from 'antd';
import queryString from 'query-string';
import React, { useEffect, useReducer, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";

import ZenFormInput from './InputCreater/ZenFormInput';
import { createRoute } from '../utils/CustomFunc';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import liracrypt from '../components/Liracrypt/liracrypt';
import ZenModal from '../components/ZenModal';
import noImg from '../assets/static/noImg.jpeg';
import Scanter from '../components/STORM/Scanter';

const initialState = {
    packingData: null,
    queryElements: null,
    leftContainer: null,
    mainContainer: null,
    scanter: null
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'setPackingData':
            return { ...state, packingData: action.payload };
        case 'setQueryElements':
            return { ...state, queryElements: action.payload };
        case 'setLeftContainer':
            return { ...state, leftContainer: action.payload };
        case 'mainContainer':
            return { ...state, mainContainer: action.payload };
        case 'setScanter':
            return { ...state, scanter: action.payload };
        default:
            return state;
    }
};

const SmtPacking = ({
    setPageHeader,
    urlData
}) => {
    const [responseLoading, setResponseLoading] = useState(false);
    const [zenModal, setZenModal] = useState();
    const [loading, setLoading] = useState(true);
    const [modal, setModal] = useState({
        // type: props.config.zenModal.typ,
        type: "",
        data: undefined,
        show: false,
        loading: false,
    });
    const toggleModal = ({ show = false, data = undefined, type = "", loading = false }) => {
        setModal({ show, data, type, loading });
    }
    const { search } = useLocation();
    const urlCode = useSelector(state => state.urlCode);
    const searchParams = queryString.parse(search);
    const [containerData, dispatch] = useReducer(reducer, initialState);
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];
    const LocalDict = [];
    const [form] = Form.useForm();

    const getData = () => {
        liracrypt.get('/textapi', { ...searchParams, ...urlData })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setPageHeader(data.config?.pageTitle);
                    dispatch({ type: "setPackingData", payload: data.data?.packingData });
                    dispatch({ type: "setQueryElements", payload: data.data?.queryElements });
                    dispatch({ type: "setScanter", payload: data.data?.scanter });
                    setLoading(false);
                } else {
                    message.error(data.message || 'Something went wrong!');
                }
            }).catch(err => {
                console.error(err);
                ApiErrorComp();
            })
    }
    const getResponse = (data) => {
        dispatch({ type: "setPackingData", payload: data?.data?.packingData });
        dispatch({ type: "setLeftContainer", payload: data?.data?.leftContainer });
        dispatch({ type: "mainContainer", payload: data?.data?.mainContainer });
        setResponseLoading(false);
        if (data?.config?.refreshPage) {
            setTimeout(() => {
                let packingData = [...containerData.packingData];
                packingData[0].data[1].text = " ";
                dispatch({ type: "setPackingData", payload: packingData});
                dispatch({ type: "setLeftContainer", payload: null });
                dispatch({ type: "mainContainer", payload: null });
            }, 5000);
        }
    }


    useEffect(() => {
        getData();
    }, []);

    const queryElements = (controls) => {
        return (
            <Row justify={"space-between"} style={{ alignItems: 'center' }}>
                {
                    controls.map((data, index) => {
                        if (dtArray.includes(data["typ"])) {

                            LocalDict[data["data_index"]] = data["format"]
                                ? data["format"]
                                : "YYYY-MM-DD hh:mm:ss";
                            LocalDict["data_index_from"] = data["data_index_from"];
                            LocalDict["data_index_to"] = data["data_index_to"];
                        }

                        if (data.visible) {
                            data.params = { ...data.params, ...form.getFieldsValue() }
                            return (
                                <React.Fragment key={index}>
                                    <ZenFormInput
                                        //    urlData={{ ...urlData }}
                                        childType={data.childType}
                                        pageType={"zenForm"}
                                        header={data.header}
                                        footer={data.footer}
                                        labelColSpan={data["labelColSpan"]}
                                        style={data['style']}
                                        height={data['height']}
                                        layoutPosition="space-between"
                                        form={form}
                                        LocalDict={LocalDict}
                                        rows={data.rows}
                                        colSpan={data.colSize || 12}
                                        name={data["data_index"]}
                                        label={data["label"]}
                                        defaultValue={data["default"]}
                                        typ={data["typ"]}
                                        disabled={data["readOnly"]}
                                        source={data["source"]}
                                        sourceParams={data["sourceParams"]}
                                        auxParams={data["auxParams"]}
                                        format={data["format"]}
                                        errorMessage={data["errorMessage"]}
                                        placeHolder={data["placeHolder"]}
                                        required={data["required"]}
                                        options={data["data"]}
                                        from={data["data_index_from"]}
                                        to={data["data_index_to"]}
                                        url={data["url"]}
                                        includeAll={data["includeAll"]}
                                        pname={data["p_data_index"]}
                                        defaultFrom={data["defaultFrom"]}
                                        defaultTo={data["defaultTo"]}
                                        multiSelect={data["multiSelect"]}
                                        searchable={data["isSearchable"]}
                                        data={data}
                                        //   extraData={extraData}
                                        children={data['children']}
                                    />
                                </React.Fragment>
                            );
                        }
                    })}
            </Row>)
    }

    const onResponse = ({ button, barCode }) => {
        if (!button?.buttonProp?.postSubmitAction) return;
        onColumnClick({ record: { barCode }, zenPop: button?.postSubmitActionProp[barCode] });
    };

    const zenPopupAction = (zenPopup, value, record) => {
        let urlData = { ...searchParams, ...zenPopup.params };
        if (zenPopup?.props) {
            urlData[zenPopup?.props] = value;
        }
        if (zenPopup?.multiProps) {
            zenPopup?.multiProps.forEach((prop) => {
                urlData[prop] = record[prop];
            });
        }
        if (zenPopup?.typ === 'smodal') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    id: value,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        };
        if (zenPopup?.typ === 'route') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    route: zenPopup?.route,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        }
        if (zenPopup?.api) {
            toggleModal({ show: true, loading: true, type: zenPopup?.typ });
            liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
                toggleModal({
                    show: true,
                    data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
                    loading: false,
                    type: zenPopup?.typ
                })
            });
            return;
        }
        return toggleModal({
            show: true,
            data: {
                urlData: { ...zenPopup?.submitData?.params },
                api: zenPopup?.submitData?.api,
                method: zenPopup?.submitData?.method
            },
            loading: false,
            type: zenPopup?.typ
        })
    }

    const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
        if (popData.method === 'GET') {
            liracrypt.get(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'POST') {
            liracrypt.post(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    console.log(err);
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'PATCH') {
            liracrypt.patch(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
    }

    const onColumnClick = ({ record, zenPop }) => {
        console.log(zenPop);
        if (zenPop) {
            let zenPopDataIndex = { ...zenPop };
            setZenModal(zenPopDataIndex);
            if (zenPopDataIndex?.typ === 'newTab') {
                let zenParams = { ...searchParams, ...zenPopDataIndex.params };
                if (zenPopDataIndex?.api) {
                    zenParams.api = zenPopDataIndex?.api;
                }
                let route = createRoute({
                    props: zenPopDataIndex?.props,
                    record,
                    multiProps: zenPopDataIndex?.multiProps,
                    params: { ...zenParams },
                    urlCode,
                    route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
                });
                window.open(route, '_blank')
                return;
            };

            if (zenPopDataIndex?.typ === 'confirmationPopUp') {
                let urlData = { ...searchParams, ...zenPopDataIndex?.onOk?.params };
                if (zenPopDataIndex?.onOk?.multiProps) {
                    zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
                        urlData[prop] = record[prop];
                    });
                };
                if (zenPopDataIndex?.onOk?.props) {
                    urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
                }

                Modal.confirm({
                    title: zenPopDataIndex?.text,
                    okText: zenPopDataIndex?.okButtonText,
                    cancelText: zenPopDataIndex?.cancelButtonText,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            onConfirmation({
                                popData: zenPopDataIndex?.onOk,
                                resolve,
                                reject,
                                urlData
                            });
                        }).catch(() => console.log('Oops errors!'));
                    }
                });
                return;
            }
            zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

        }
    }

    const onScanterFinish = ({ button, barCode }) => {
        setResponseLoading(true);
        let postData = { ...searchParams, ...urlData, ...button?.submitFormDataProp.params, ...form.getFieldsValue() };
        postData.barCode = barCode;
        console.log(button, postData)
        if (button?.submitFormDataProp?.method === 'POST') {
            liracrypt.post(button?.submitFormDataProp.url, postData).then(response => {
                if (response.data.isSuccess) {
                    notification.success({ message: response.data.message });
                    getResponse(response.data);
                } else {
                    notification.error({ message: response.data.message })
                }
            })
                .catch(err => {
                    notification.error({
                        message: 'Something went wrong'
                    })
                })
        };
        if (button?.submitFormDataProp?.method === 'GET') {
            liracrypt.get(button?.submitFormDataProp.url, postData).then(response => {
                if (response.data.isSuccess) {
                    notification.success({ message: response.data.message });
                    getResponse(response.data);
                } else {
                    notification.error({ message: response.data.message })
                }
            })
                .catch(err => {
                    notification.error({
                        message: 'Something went wrong'
                    })
                })
        };
        if (button?.submitFormDataProp?.method === 'PATCH') {
            liracrypt.patch(button?.submitFormDataProp.url, postData).then(response => {
                if (response.data.isSuccess) {
                    notification.success({ message: response.data.message });
                    getResponse(response.data);
                } else {
                    notification.error({ message: response.data.message })
                }
            })
                .catch(err => {
                    notification.error({
                        message: 'Something went wrong'
                    })
                })
        };
    }

    const scanterCallback = () => {
        setTimeout(() => {
            toggleModal({ show: false, data: undefined, type: "", loading: false });
            setZenModal(undefined);
            setLoading(true);
            getData();
        }, 5000);
    }

    return (
        <div className='' style={{ padding: 10 }}>
            <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} scanterCallback={scanterCallback} smodalCallback={() => {
                setLoading(true);
                getData();
            }} />
            {
                loading ?
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                        <LoadingOutlined
                            style={{ fontSize: 80, color: "#007bff" }}
                            spin
                        />
                    </div> :
                    <div className='pcb-barcode-container'>
                        <div className={`AuditSection CreateAudit`}>
                            <div className={`ThemeForm phantom-form`}>
                                <Form
                                    name={`ReportForm `}
                                    form={form}
                                    labelWrap={true}
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    layout="horizontal"
                                    colon={false}
                                    onFinish={() => { }}
                                    size="large"
                                >
                                    {
                                        queryElements(containerData.queryElements)
                                    }
                                </Form>
                            </div>
                        </div>
                        <Row style={{ marginTop: 10, border: '1px solid #1677FF', borderRadius: 10, padding: 10, alignItems: 'center' }}>
                            <Col span={12} style={{ paddingRight: 10 }}>
                                <Scanter
                                    disableScanter={modal?.show}
                                    onFinish={onScanterFinish}
                                    postSubmitAction={onResponse}
                                    openPopupModal={() => { }}
                                    button={containerData?.scanter}
                                    // setSelectedButton={setSelectedButton}
                                    form={null}
                                    label={containerData?.scanter?.buttonProp?.label}
                                    type={containerData?.scanter?.buttonProp?.type}
                                    disabled={!containerData?.scanter?.buttonProp?.enable}
                                    confirmationPopUp={containerData?.scanter?.buttonProp?.confirmationPopUp ? containerData?.scanter?.confirmationPopUpProp : undefined}
                                    submitFormData={containerData?.scanter?.submitFormDataProp}
                                />
                            </Col>
                            <Col span={12}>
                                {
                                    queryElements(containerData.packingData)
                                }
                            </Col>
                        </Row>
                        <Row style={{ marginTop: 10 }}>
                            {
                                containerData.leftContainer?.length > 0 ?
                                    <Col span={6} style={{ paddingRight: 10 }}>
                                        {
                                            queryElements(containerData.leftContainer)
                                        }
                                    </Col> : null
                            }
                            {
                                responseLoading ?
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                                        <LoadingOutlined
                                            style={{ fontSize: 80, color: "#007bff" }}
                                            spin
                                        />
                                    </div> :

                                    containerData.mainContainer?.length > 0 ?
                                        <Col span={18}>
                                            {queryElements(containerData.mainContainer)}
                                        </Col> : null
                            }
                        </Row>
                    </div>
            }
        </div>
    )
};

export default SmtPacking;